import React, { useState, useCallback, useEffect } from "react";
import { Box, Container, View, Title } from "@common/components";
import { connect } from "react-redux";
import { Button, Table, Tabs } from "antd";
import ReactExport from "react-data-export";
import {
  getBankStatementColumns,
  getTithelyColumns,
  getSummaryColumns,
} from "./columns";
import { processBankStatements } from "./bankStatementProcessorImproved";
import { processTithelyData } from "./tithelyProcessorImproved";

const { TabPane } = Tabs;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Extraction = ({
  categories,
  exceptions,
  inputs,
  members,
  bankStatements,
  tithelies,
}) => {
  const [loading, setLoading] = useState(false);
  const [bankStatementData, setBankStatementData] = useState([]);
  const [tithelyData, setTithelyData] = useState([]);
  const [cats] = useState([...categories]);
  const [exs] = useState([...exceptions]);
  const [mems] = useState([...members]);
  const [inps] = useState(
    [...inputs].filter((input) => {
      return (
        cats
          .sort((a, b) => b.title.length - a.title.length)
          .find((cat) => cat.id === input.category) !== undefined
      );
    }),
  );

  useEffect(() => {
    return () => {
      setBankStatementData([]);
      setTithelyData([]);
    };
  }, []);

  const [sortedInfo, setSortedInfo] = useState({});
  const handleChange = useCallback(
    (pagination, filters, sorter) => {
      setSortedInfo(sorter);
    },
    [setSortedInfo],
  );

  const handleSearch = useCallback((selectedKeys, confirm) => {
    confirm();
  }, []);

  const handleReset = useCallback((clearFilters) => {
    clearFilters();
  }, []);

  // Generate column configurations
  const bankStatementColumns = getBankStatementColumns(
    cats,
    sortedInfo,
    handleSearch,
    handleReset,
  );

  const tithelyColumns = getTithelyColumns(
    cats,
    sortedInfo,
    handleSearch,
    handleReset,
  );

  const summaryColumn = getSummaryColumns(
    cats,
    sortedInfo,
    handleSearch,
    handleReset,
  );

  const bankStatementTable = () => {
    return processBankStatements(bankStatements, mems, exs, cats, inps);
  };

  const tithelyTable = () => {
    return processTithelyData(tithelies, mems, exs, cats, inps);
  };

  return (
    <View>
      <Container>
        <Box flex>
          <Title>Extractor</Title>

          <Tabs defaultActiveKey="1">
            <TabPane tab="Bank Statement" key="1">
              <Title fontSize={20}>Bank Statement</Title>

              {mems &&
              mems.length > 0 &&
              bankStatements &&
              bankStatements &&
              bankStatements.length > 0 ? (
                bankStatementData &&
                bankStatementData.data &&
                bankStatementData.data.length > 0 ? (
                  <>
                    <ExcelFile
                      element={
                        <Button type="primary">
                          Download {`GIB${bankStatements[0].workdate}`}
                        </Button>
                      }
                      filename={`GIB${bankStatements[0].workdate}`}
                    >
                      <ExcelSheet
                        data={bankStatementData.data}
                        name="Bank Statement"
                      >
                        <ExcelColumn label="Category" value="category" />
                        <ExcelColumn label="Entity Key" value="entity" />
                        <ExcelColumn label="Date" value="date" />
                        <ExcelColumn label="For Period" value="remarks" />
                        <ExcelColumn label="Amount" value="amount" />
                        <ExcelColumn label="ID" value="id" />
                        <ExcelColumn label="Center" value="cong" />
                        <ExcelColumn label="Service" value="region" />
                        <ExcelColumn
                          label="Transaction Description 2"
                          value="description2"
                        />
                        <ExcelColumn label="Remarks" value="remarks2" />
                        <ExcelColumn label="Status" value="status" />
                      </ExcelSheet>

                      <ExcelSheet
                        data={bankStatementData.summary}
                        name="Summary"
                      >
                        <ExcelColumn label="Category" value="category" />
                        <ExcelColumn label="Center" value="cong" />
                        <ExcelColumn label="Service" value="region" />
                        <ExcelColumn label="Total" value="total" />
                      </ExcelSheet>
                    </ExcelFile>
                    <br />
                    <br />

                    <Title fontSize={15}>Statement</Title>
                    <Table
                      scroll={{ x: 1500 }}
                      columns={bankStatementColumns}
                      dataSource={bankStatementData.data}
                      onChange={handleChange}
                    />
                    <br />
                    <br />

                    <Title fontSize={15}>Summary</Title>
                    <Table
                      columns={summaryColumn}
                      dataSource={bankStatementData.summary}
                      onChange={handleChange}
                    />
                  </>
                ) : (
                  <Box>
                    <Button
                      loading={loading}
                      onClick={() => {
                        setLoading(true);
                        setBankStatementData(bankStatementTable());
                        setLoading(false);
                      }}
                    >
                      Process Bank Statment Extraction
                    </Button>
                  </Box>
                )
              ) : (
                "You need to upload the members and the bank statement CSV in order to extract"
              )}
            </TabPane>
            <TabPane tab="Tithely" key="2">
              <Title fontSize={20}>Tithely</Title>

              {mems && mems.length > 0 && tithelies && tithelies.length > 0 ? (
                tithelyData &&
                tithelyData.data &&
                tithelyData.data.length > 0 ? (
                  <>
                    <ExcelFile
                      element={
                        <Button type="primary">
                          Download {`GLY${tithelies[0].workdate}`}
                        </Button>
                      }
                      filename={`GLY${tithelies[0].workdate}`}
                    >
                      <ExcelSheet data={tithelyData.data} name="Tithely">
                        <ExcelColumn label="Category" value="category" />
                        <ExcelColumn label="Entity Key" value="entity" />
                        <ExcelColumn label="Date" value="date" />
                        <ExcelColumn label="For Period" value="remarks" />
                        <ExcelColumn label="Amount" value="amount" />
                        <ExcelColumn label="ID" value="id" />
                        <ExcelColumn label="Center" value="cong" />
                        <ExcelColumn label="Service" value="region" />
                        <ExcelColumn label="Giving Type" value="type" />
                        <ExcelColumn
                          label="Check / iBank / NETS Number"
                          value="checkIbankNets"
                        />
                        <ExcelColumn label="Memo / Note" value="memo" />
                        <ExcelColumn label="Backdate" value="backdate" />
                        <ExcelColumn label="Remarks" value="remarks2" />
                        <ExcelColumn label="Status" value="status" />
                      </ExcelSheet>

                      <ExcelSheet data={tithelyData.summary} name="Summary">
                        <ExcelColumn label="Category" value="category" />
                        <ExcelColumn label="Center" value="cong" />
                        <ExcelColumn label="Service" value="region" />
                        <ExcelColumn label="Total" value="total" />
                      </ExcelSheet>
                    </ExcelFile>
                    <br />
                    <br />

                    <Title fontSize={15}>Statement</Title>
                    <Table
                      scroll={{ x: 1500 }}
                      columns={tithelyColumns}
                      dataSource={tithelyData.data}
                      onChange={handleChange}
                    />
                    <br />
                    <br />

                    <Title fontSize={15}>Summary</Title>
                    <Table
                      columns={summaryColumn}
                      dataSource={tithelyData.summary}
                      onChange={handleChange}
                    />
                  </>
                ) : (
                  <Box>
                    <Button
                      loading={loading}
                      onClick={() => {
                        setLoading(true);
                        setTithelyData(tithelyTable());
                        setLoading(false);
                      }}
                    >
                      Process Tithely Extraction
                    </Button>
                  </Box>
                )
              ) : (
                "You need to upload the members and the tithely CSV in order to extract"
              )}
            </TabPane>
          </Tabs>
        </Box>
      </Container>
    </View>
  );
};

const mapStateToProps = ({
  categories,
  exceptions,
  members,
  bankStatements,
  tithelies,
  inputs,
}) => ({ categories, exceptions, members, bankStatements, tithelies, inputs });

export default connect(mapStateToProps, {})(Extraction);
